<div class="flex flex-col">
  <div class="flex items-start gap-3 mb-4">
    <div class="w-1 h-8 bg-[#3D3DF4] rounded-full shrink-0"></div>
    <h2 class="text-lg font-bold text-gray-900 dark:text-white leading-tight">Mi Empresa</h2>
  </div>
  <div
    class="bg-white dark:bg-[var(--color-dark-bg-secondary)] border border-gray-200 dark:border-gray-700 rounded-[1.5rem] md:rounded-2xl p-5 md:p-6 flex-1">
    <div class="flex flex-col gap-5 md:flex-row md:items-center md:justify-between w-full">
      <div class="min-w-0">
        <div class="inline-flex md:hidden items-center rounded-full bg-[#EEF2FF] dark:bg-[var(--color-dark-bg-primary)] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-[#3D3DF4] dark:text-[#5D5DF6]">
          Perfil empresarial
        </div>
        <p class="text-4xl font-bold text-[#3D3DF4] mt-3">{{ progress }}%</p>
        <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Datos completados</p>
        <div class="md:hidden h-2.5 rounded-full bg-gray-100 dark:bg-gray-800 mt-4 overflow-hidden">
          <div class="h-full rounded-full bg-[#3D3DF4]" [style.width.%]="progress"></div>
        </div>
        <div class="flex items-center gap-2 mt-4 text-sm text-gray-600 dark:text-gray-300">
          <fa-icon [icon]="faFile" class="text-gray-400"></fa-icon>
          {{ documentCount }} documentos subidos
        </div>
        @if (progress < 100) {
        <button (click)="completeRequested.emit()"
          class="mt-4 inline-flex items-center gap-1.5 px-4 py-2.5 text-xs font-semibold text-[#3D3DF4] bg-[#3D3DF4]/10 hover:bg-[#3D3DF4]/20 rounded-xl transition-colors cursor-pointer md:mt-3 md:px-3 md:py-1.5 md:rounded-lg md:font-medium">
          Completar datos <fa-icon [icon]="faChevronRight" class="text-[10px] ml-1"></fa-icon>
        </button>
        }
      </div>

      <div class="relative w-24 h-24 mx-auto md:mx-0 shrink-0">
        <svg class="w-24 h-24 -rotate-90" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="42" fill="none" stroke="#E5E7EB" stroke-width="8" class="dark:stroke-gray-700" />
          <circle cx="50" cy="50" r="42" fill="none" stroke="#3D3DF4" stroke-width="8" class="progress-circle"
            stroke-linecap="round" [attr.stroke-dasharray]="2 * 3.14159 * 42" [attr.stroke-dashoffset]="progressOffset" />
        </svg>
        <div class="absolute inset-0 flex items-center justify-center">
          <fa-icon [icon]="faBadgeCheck" class="text-2xl text-[#3D3DF4]"></fa-icon>
        </div>
      </div>
    </div>
  </div>
</div>
